module.exports = __webpack_public_path__ + "348d8a4e5ee03ee36cc64b21b718afce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/eyepatch-s.png
// module id = 2429
// module chunks = 0